import { createFileRoute } from "@tanstack/react-router";
import { EsPlaceholder, esHead } from "@/knowmeno/marketing/EsPlaceholder";

export const Route = createFileRoute("/es/privacidad")({
  head: () => esHead({
    path: "/privacidad",
    title: "Política de Privacidad | SepaMeno",
    description: "Cómo SepaMeno protege tu información personal y de salud.",
    englishPath: "/privacy",
  }),
  component: () => (
    <EsPlaceholder
      title="Política de Privacidad"
      subtitle="Estamos preparando la versión en español. Nuestra política en inglés aplica para todas las usuarias mientras tanto."
      englishHref="https://knowmeno.com/privacy"
    />
  ),
});
